<div class="statusArea time">
  <ng-container *ngIf="fixtureItem.TimeStatu < 3">
    <p>{{fixtureItem.TimeStatuColor}}</p>
  </ng-container>

</div>
<div class="nine wide divOdd" style="text-align:center">
  <div class="oddGroup secondLine">
    <oddView [typeOfList]=typeOfList
             [_data]="oddValues[0]"
             [rowNumber]=1
             [oddNumber]="3"
             [matchID]="fixtureItem.matchID"
             [specialValShow]="false"
             [fixtureItem]="fixtureItem"
             [hidingOfFirst]="hidingOfFirst"

    >
    </oddView>
    <oddView [typeOfList]=typeOfList
             [_data]="oddValues[1]"
             [rowNumber]=2
             [oddNumber]="2"
             [matchID]="fixtureItem.matchID"
             [fixtureItem]="fixtureItem">

    </oddView>
    <oddView [typeOfList]=typeOfList
             [_data]="oddValues[2]"
             [rowNumber]=3
             [oddNumber]="3"
             [matchID]="fixtureItem.matchID"
             [fixtureItem]="fixtureItem"
             [hidingOfThird]="hidingOfThird"

    >
    </oddView>

  </div>

</div>
